import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteProperty } from "api/properties";

import { queryKeys } from "./queryKeys";

export const useDeleteProperty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProperty,
    onSuccess: (data, propertyId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.properties.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.properties.lists() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.properties.detail(propertyId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.properties.organization(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenantReports.lists(),
      });
    },
  });
};
